import {
  MessageInputProps,
  MessageInput,
  MessageSimple,
  Thread,
  useChannelStateContext,
  useMessageContext,
} from 'stream-chat-react';
import { renderMessage } from '@features/components/Chat/components/ChatContent/Messages/utils/renderCustomMessages';
import { MESSAGE_INPUT_MAX_ROWS } from '@features/components/Chat/constants';

const ReadOnlyThreadInput = ({ readOnlyMessage }: { readOnlyMessage?: string }) => (
  <p className="text-gray-700 text-center p-4">{readOnlyMessage ?? ''}</p>
);

const ThreadInput = (props: MessageInputProps) => <MessageInput {...props} maxRows={MESSAGE_INPUT_MAX_ROWS} focus />;

const CustomThreadMessage = () => {
  const { message, ...context } = useMessageContext();
  const enrichedMessage = renderMessage(message);
  return (
    <MessageSimple
      {...context}
      message={enrichedMessage}
      additionalMessageInputProps={{ maxRows: MESSAGE_INPUT_MAX_ROWS, ...context.additionalMessageInputProps }}
    />
  );
};

export const RightSideThread = ({
  isReadOnly,
  readOnlyMessage,
}: {
  isReadOnly?: boolean;
  readOnlyMessage?: string;
}) => {
  const { thread } = useChannelStateContext();

  if (!thread) return null;

  const InputComponent = isReadOnly ? () => <ReadOnlyThreadInput readOnlyMessage={readOnlyMessage} /> : ThreadInput;

  return (
    <div className="h-full bg-white z-50 shadow-lg border-l border-base-60 flex flex-col">
      <Thread
        Message={CustomThreadMessage}
        Input={InputComponent}
        additionalMessageListProps={{
          closeReactionSelectorOnClick: true,
        }}
      />
    </div>
  );
};
